import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Examinee } from '../shared/models/examinee.model';
import { Questionnaire } from '../shared/models/questionnaire.model';
import { EulaAgreementComponent } from '../shared/components/eula-agreement/eula-agreement.component';
import { ExamineeService } from '../services/examinee.service';
import { StreamService } from '../services/stream.service';

@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrl: './assessment.component.scss'
})
export class AssessmentComponent implements OnInit {
	@ViewChild('eulaAgreement') eulaAgreement!: EulaAgreementComponent;

	logo = './../../../assets/images/logo/logo-dark-wide.png';

	token = null;
	loading = false;
	access = true;
	startQuestionnaire = false;
	submitted = false;
	spinner = false;

	examinee!: Examinee;
	questionnaire!: Questionnaire;

	allowNext = false;

	steps = ['GUIDENESS', 'CAM_MIC_SETTINGS', 'DESCRIPTION'];
	currentStep = 0;


	constructor(private translate: TranslateService, private examineeService: ExamineeService) { }

	ngOnInit(): void {
		this.examinee = this.examineeService.examineeValue;
		this.questionnaire = this.examineeService.questionnaireValue;
		
		this.translate.use(this.questionnaire.lang_code);

		if (!this.questionnaire.description || this.questionnaire.description === '') {
			this.steps = ['GUIDENESS', 'CAM_MIC_SETTINGS'];
		}
	}

	nextStep() {
		this.submitted = true;

		if (this.currentStep < this.steps.length-1) {
			switch (this.currentStep) {
				case 0:
					// Do guideness page (instruction to for the user what to do and what not to do)
					this.currentStep++;
					this.allowNext = false;
					break;
				case 1:
					// Do setting page to check camera and position
					this.currentStep++;
					this.allowNext = false;
					break;
				case 2:
					// Do questionnaire description page (if exist if show start button)
					break;
				default:
					break;
			}
		} else {
			if (this.currentStep === this.steps.length-1) {
				this.spinner = true;

				this.startQuestionnaire = true;

				this.examineeService.updateExamineeStart().subscribe(() => {
					this.spinner = false;
					this.startQuestionnaire = true;
				});
			}
		}
  }

	settingsCheck(event: any) {
		setTimeout(() => {
			this.allowNext = event;
		});
	}

	backStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }
}
